import { accounts as accountsAT } from './lib/accounts-config/AT';
import { accounts as accountsBase } from './lib/accounts-config/base';
import { accounts as accountsCZ } from './lib/accounts-config/CZ';
import { accounts as accountsHU } from './lib/accounts-config/HU';
import { accounts as accountsHR } from './lib/accounts-config/HR';
import { accounts as accountsRO } from './lib/accounts-config/RO';
import { accounts as accountsRS } from './lib/accounts-config/RS';
import { accounts as accountsSK } from './lib/accounts-config/SK';
import { buildingSociety as buildingSocietyAT } from './lib/building-society-config/AT';
import { buildingSociety as buildingSocietyBase } from './lib/building-society-config/base';
import { buildingSociety as buildingSocietyCZ } from './lib/building-society-config/CZ';
import { buildingSociety as buildingSocietyHU } from './lib/building-society-config/HU';
import { buildingSociety as buildingSocietyHR } from './lib/building-society-config/HR';
import { buildingSociety as buildingSocietyRO } from './lib/building-society-config/RO';
import { buildingSociety as buildingSocietySK } from './lib/building-society-config/SK';
import { currentAccount as accountsCurrentAT } from './lib/accounts-config/current-config/AT';
import { currentAccount as accountsCurrentBase } from './lib/accounts-config/current-config/base';
import { currentAccount as accountsCurrentCZ } from './lib/accounts-config/current-config/CZ';
import { currentAccount as accountsCurrentHU } from './lib/accounts-config/current-config/HU';
import { currentAccount as accountsCurrentHR } from './lib/accounts-config/current-config/HR';
import { currentAccount as accountsCurrentRO } from './lib/accounts-config/current-config/RO';
import { currentAccount as accountsCurrentSK } from './lib/accounts-config/current-config/SK';
import { currentAccount as accountsCurrentRS } from './lib/accounts-config/current-config/RS';
import { statements as statementsAT } from './lib/statements-config/AT';
import { statements as statementsBase } from './lib/statements-config/base';
import { statements as statementsCZ } from './lib/statements-config/CZ';
import { statements as statementsHU } from './lib/statements-config/HU';
import { statements as statementsHR } from './lib/statements-config/HR';
import { statements as statementsRO } from './lib/statements-config/RO';
import { statements as statementsSK } from './lib/statements-config/SK';
import { statements as statementsRS } from './lib/statements-config/RS';
import { savings as savingsAT } from './lib/savings-config/AT';
import { savings as savingsBase } from './lib/savings-config/base';
import { savings as savingsCZ } from './lib/savings-config/CZ';
import { savings as savingsHU } from './lib/savings-config/HU';
import { savings as savingsHR } from './lib/savings-config/HR';
import { savings as savingsRO } from './lib/savings-config/RO';
import { savings as savingsSK } from './lib/savings-config/SK';
import { savings as savingsRS } from './lib/savings-config/RS';
import { productsFeaturesAT } from './lib/phoebe-flags/AT';
import { productsFeaturesCZ } from './lib/phoebe-flags/CZ';
import { productsFeaturesHU } from './lib/phoebe-flags/HU';
import { productsFeaturesHR } from './lib/phoebe-flags/HR';
import { productsFeaturesSK } from './lib/phoebe-flags/SK';
import { productsFeaturesRO } from './lib/phoebe-flags/RO';
import { productsFeaturesRS } from './lib/phoebe-flags/RS';

export const StatementFeatureConfig = {
    AT: statementsAT,
    base: statementsBase,
    CZ: statementsCZ,
    HR: statementsHR,
    HU: statementsHU,
    RO: statementsRO,
    SK: statementsSK,
    RS: statementsRS,
};

export const SavingsFeatureConfig = {
    AT: savingsAT,
    base: savingsBase,
    CZ: savingsCZ,
    HR: savingsHR,
    HU: savingsHU,
    RO: savingsRO,
    SK: savingsSK,
    RS: savingsRS,
};

export const AccountsFeatureConfig = {
    AT: accountsAT,
    base: accountsBase,
    CZ: accountsCZ,
    HR: accountsHR,
    HU: accountsHU,
    RO: accountsRO,
    SK: accountsSK,
    RS: accountsRS,
};

export const AccountsCurrentFeatureConfig = {
    AT: accountsCurrentAT,
    base: accountsCurrentBase,
    CZ: accountsCurrentCZ,
    HR: accountsCurrentHR,
    HU: accountsCurrentHU,
    RO: accountsCurrentRO,
    SK: accountsCurrentSK,
    RS: accountsCurrentRS,
};

export const BuildingSocietyFeatureConfig = {
    AT: buildingSocietyAT,
    base: buildingSocietyBase,
    CZ: buildingSocietyCZ,
    HR: buildingSocietyHR,
    HU: buildingSocietyHU,
    RO: buildingSocietyRO,
    SK: buildingSocietySK,
};

export const ProductsPhoebeFlag = {
    AT: productsFeaturesAT,
    CZ: productsFeaturesCZ,
    SK: productsFeaturesSK,
    HU: productsFeaturesHU,
    HR: productsFeaturesHR,
    RO: productsFeaturesRO,
    RS: productsFeaturesRS,
};

export type { ProductsFeatures } from './lib/ProductFeatures';
export { ProductsFeatureConfig } from './lib/ProductsFeatureConfig';
export type {
    AccountsConfig,
    BuildingSocietyConfig,
    StatementsConfig,
    SavingsConfig,
} from './lib/ProductsConfig';
